// client/src/context/AuthContext.js
import React, { createContext, useState, useEffect, useContext } from 'react';
import axios from 'axios';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (token) {
            // Call your backend /auth/user route to get the user's ID and login
            axios.get('/auth/user', {
                headers: { Authorization: `Bearer ${token}` }
            })
                .then(res => setUser(res.data))
                .catch(() => localStorage.removeItem('token')) // Token is invalid/expired
                .finally(() => setLoading(false));
        } else {
            setLoading(false);
        }
    }, []);

    // Call this function after a user logs in
    const login = (token) => {
        localStorage.setItem('token', token);
        axios.get('/auth/user', {
            headers: { Authorization: `Bearer ${token}` }
        }).then(res => setUser(res.data));
    };

    // Call this function when a user logs out
    const logout = () => {
        localStorage.removeItem('token');
        setUser(null);
    };

    return (
        <AuthContext.Provider value={{ user, login, logout, loading }}>
            {children}
        </AuthContext.Provider>
    );
};